import React, { useState, useEffect } from 'react';
import SideNavbar from './helpers/SideNavbar';
import { useNavigate, Link } from "react-router-dom";
import SubscriptionStatus from './subscriptionstatus';
import Swal from 'sweetalert2';
import { useFetchLocalizedPlans } from '../apis/payment';




const PricingSection = () => {
  const navigate = useNavigate();

  const [personalPlan, setPersonalPlan] = useState("Monthly");
  const [businessPlan, setBusinessPlan] = useState("Monthly");
  const [agencyPlan, setAgencyPlan] = useState("Monthly");
  const SubscriptionType = localStorage.getItem('SubscriptionType');
  const subscriptionEndDate = localStorage.getItem('subscriptionEndDate');
  const userId = localStorage.getItem('UserID');
  const roleId = Number(localStorage.getItem('RoleID'));
  
  // Check if user has active subscription
  const hasActiveSubscription = SubscriptionType && SubscriptionType !== 'null' && 
                                subscriptionEndDate && subscriptionEndDate !== 'null';
  
  // Calculate next payment date
  const getNextPaymentDate = () => {
    if (!hasActiveSubscription) return null;
    
    const endDate = new Date(subscriptionEndDate);
    const today = new Date();
    
    // If subscription hasn't ended yet, next payment is the end date
    if (endDate > today) {
      return endDate;
    }
    
    return null;
  };
  
  const nextPaymentDate = getNextPaymentDate();

  const { data: localized, isLoading: isLoadingPlans } = useFetchLocalizedPlans(userId);
  const currencySymbol = localized?.currency === 'INR' ? '₹' : '$';
  const personalMonthly = localized?.pricing?.monthly ? localized.pricing.monthly / 100 : null;
  const personalYearly = localized?.pricing?.yearly ? localized.pricing.yearly / 100 : null;
  // Agency uses same pricing as personal/business for now
  const agencyMonthly = personalMonthly * 10; // 10x personal price
  const agencyYearly = personalYearly * 10;   // 10x personal price

  const handleSelect = (plan, type) => {
    let amount = 0;
    let priceId = null;

    if (type === "personal" || type === "business") {
      amount = plan === "Annually" ? personalYearly : personalMonthly;
      priceId = plan === "Annually" ? localized?.priceIds?.yearly : localized?.priceIds?.monthly;
    } else if (type === "agency") {
      amount = plan === "Annually" ? agencyYearly : agencyMonthly;
      // For agency, we'll use the same price IDs as personal (you may want to create separate agency price IDs in Stripe)
      priceId = plan === "Annually" ? localized?.priceIds?.yearly : localized?.priceIds?.monthly;
    }

    navigate("/Payment", { state: { amount, type, plan, currency: localized?.currency, priceId } });

  };
  useEffect(() => {
    // Refresh feature limits data when subscription page loads
    if (window.refreshFeatureUsage) {
      window.refreshFeatureUsage();
    }
    
    const showAlert = localStorage.getItem("showPostPaymentAlert");

    if (showAlert === "true") {
      Swal.fire({
        title: "Action Required",
        text: "Please logout and login again to access all features.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#2e3192"
      });

      localStorage.removeItem("showPostPaymentAlert");
    }
  }, []);



  return (
    <SideNavbar>
      <div><SubscriptionStatus /></div>
      <div className="card shadow-sm p-3" style={{ border: "none", backgroundColor: "#fff" }}>
       <div
  className="card-header d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center"
  style={{ border: "none", backgroundColor: "#fff" }}
>
  <h5
    className="welcome-text"
    style={{ fontSize: "20px", color: "#2e3192", margin: 0 }}
  >
    Subscription
  </h5>

  {hasActiveSubscription && (
      <div className="d-flex flex-column flex-sm-row align-items-sm-center gap-2 mt-2 mt-sm-0">
        {localStorage.getItem('IsActive') == "true" && (<div className="d-flex flex-column">
          <div className="d-flex align-items-center mb-1">
            <span className="badge me-2 px-2 py-1" style={{ fontSize: '11px', fontWeight: '600', backgroundColor: '#2e3192', color: '#fff', borderRadius: '12px' }}>✨ Premium</span>
            <span style={{ fontSize: '14px', color: '#000', fontWeight: 600 }}>Active Subscription</span>
            <span className="text-muted" style={{ fontSize: '14px', marginLeft: '10px' }}>— billed {String(SubscriptionType || '').toLowerCase()}</span>
          </div>
          <p className="mb-0" style={{ fontSize: '14px', color: '#666', marginLeft: '10px' }}>
            Valid until: {new Date(subscriptionEndDate).toLocaleDateString()}
            {/* {nextPaymentDate && (
              <span style={{ marginLeft: '10px' }}> • Next payment: {nextPaymentDate.toLocaleDateString()}</span>
            )} */}
          </p>
        </div>)}
        <Link
          className="btn"
          style={{ backgroundColor: '#2e3192', color: "#fff", whiteSpace: 'nowrap' }}
          to="/paymentManager"
        >
          Manage Subscriptions
        </Link>
      </div>
    )}
</div>


        <hr />
        <div className="container">
          <div className="row mt-2 justify-content-center">

            {/* Personal Branding */}
            {roleId === 1 && (
            <div className="col-12 col-md-6 col-lg-4 mx-auto">
              <div className="card shadow-lg text-center p-3 mt-3" style={{ border: 'none', height: "420px", maxWidth: '420px', margin: '0 auto' }}>
                <h4 className="mb-3">Personal Branding</h4>
                <div className="mb-2" style={{ height: "120px" }}>
                  {isLoadingPlans || !personalMonthly || !personalYearly ? (
                    <>
                      <p className="text-dollar" style={{ fontSize: '25px', fontWeight: '600' }}>Loading...</p>
                      <p>Please wait</p>
                    </>
                  ) : personalPlan === "Monthly" ? (
                    <>
                      <p className="text-dollar" style={{ fontSize: '25px', fontWeight: '600' }}>{currencySymbol}{personalMonthly}</p>
                      <p>billed Monthly</p>
                    </>
                  ) : (
                    <>
                      <p className="text-dollar" style={{ fontSize: '25px', fontWeight: '600' }}>{currencySymbol}{personalYearly}</p>
                      <p>billed annually (2 Months Free)</p>
                    </>
                  )}
                </div>
                <div className="text-center mt-3 mb-3">
                  <button
                    className='btn btn-primary'
                    style={{ borderRadius: "20px" }}
                    onClick={() => handleSelect(personalPlan, "personal")}
                    disabled={isLoadingPlans || !personalMonthly || !personalYearly}
                  >
                    {isLoadingPlans ? 'Loading...' : (hasActiveSubscription ? 'Upgrade' : 'Pay')}
                  </button>
                </div>
                <div className="toggle-container text-center mx-auto">
                  <div
                    className={`toggle-button ${personalPlan === "Monthly" ? "Monthly" : ""}`}
                    onClick={() => setPersonalPlan("Monthly")}
                  >
                    Monthly
                  </div>
                  <div
                    className={`toggle-button ${personalPlan === "Annually" ? "Annually" : ""}`}
                    onClick={() => setPersonalPlan("Annually")}
                  >
                    Annually
                  </div>
                </div>
                <p className='mt-3' style={{ fontWeight: 'bold' }}>
                  {personalPlan === "Monthly" ? "(Switch to annual plan to get 2 months free)" : "(2 Months Free)"}
                </p>              </div>
            </div>
            )}

            {/* Business Branding */}
            {roleId === 4 && (
            <div className="col-12 col-md-6 col-lg-4 mx-auto">
              <div className="card shadow-lg text-center p-3 mt-3" style={{ border: 'none', height: "420px", maxWidth: '420px', margin: '0 auto' }}>
                <h4 className="mb-3">Business Branding</h4>
                <div className="mb-2" style={{ height: "120px" }}>
                  {isLoadingPlans || !personalMonthly || !personalYearly ? (
                    <>
                      <p className="text-dollar" style={{ fontSize: '25px', fontWeight: '600' }}>Loading...</p>
                      <p>Please wait</p>
                    </>
                  ) : businessPlan === "Monthly" ? (
                    <>
                      <p className="text-dollar" style={{ fontSize: '25px', fontWeight: '600' }}>{currencySymbol}{personalMonthly}</p>
                      <p>billed Monthly</p>
                    </>
                  ) : (
                    <>
                      <p className="text-dollar" style={{ fontSize: '25px', fontWeight: '600' }}>{currencySymbol}{personalYearly}</p>
                      <p>billed annually (2 Months Free)</p>
                    </>
                  )}
                </div>
                <div className="text-center mt-3 mb-3">
                  <button
                    className='btn btn-primary'
                    style={{ borderRadius: "20px" }}
                    onClick={() => handleSelect(businessPlan, "business")}
                    disabled={isLoadingPlans || !personalMonthly || !personalYearly}
                  >
                    {isLoadingPlans ? 'Loading...' : (hasActiveSubscription ? 'Upgrade' : 'Pay')}
                  </button>
                </div>
                <div className="toggle-container text-center mx-auto">
                  <div
                    className={`toggle-button ${businessPlan === "Monthly" ? "Monthly" : ""}`}
                    onClick={() => setBusinessPlan("Monthly")}
                  >
                    Monthly
                  </div>
                  <div
                    className={`toggle-button ${businessPlan === "Annually" ? "Annually" : ""}`}
                    onClick={() => setBusinessPlan("Annually")}
                  >
                    Annually
                  </div>
                </div>
                <p className='mt-3' style={{ fontWeight: 'bold' }}>
                  {businessPlan === "Monthly" ? "(Switch to annual plan to get 2 months free)" : "(2 Months Free)"}
                </p>
              </div>
            </div>
            )}

            {/* Agency */}
            {roleId === 2 && (
            <div className="col-12 col-md-6 col-lg-4 mx-auto">
              <div className="card shadow-lg text-center p-3 mt-3" style={{ border: "none", height: "420px", maxWidth: '420px', margin: '0 auto' }}>
                <h4 className="mb-3">Agency</h4>
                <div className="mb-2" style={{ height: "120px" }}>
                  <div>
                    {isLoadingPlans || !personalMonthly || !personalYearly ? (
                      <>
                        <p className="text-dollar" style={{ fontSize: "25px", fontWeight: "600" }}>Loading...</p>
                        <p>Please wait</p>
                      </>
                    ) : agencyPlan === "Monthly" ? (
                      <>
                        <p className="text-dollar" style={{ fontSize: "25px", fontWeight: "600" }}>{currencySymbol}{agencyMonthly}</p>
                        <p>billed Monthly</p>
                      </>
                    ) : (
                      <>
                        <p className="text-dollar" style={{ fontSize: "25px", fontWeight: "600" }}>{currencySymbol}{agencyYearly}</p>
                        <p>billed annually (2 Months Free)</p>
                      </>
                    )}
                  </div>
                  <p className="text-gray-600">This subscription can manage 20 users</p>

                </div>

                <div className="text-center mt-3 mb-3">
                  <button
                    className='btn btn-primary'
                    style={{ borderRadius: "20px" }}
                    onClick={() => handleSelect(agencyPlan, "agency")}
                    disabled={isLoadingPlans || !personalMonthly || !personalYearly}
                  >
                    {isLoadingPlans ? 'Loading...' : (hasActiveSubscription ? 'Upgrade' : 'Pay')}
                  </button>
                </div>
                <div className="toggle-container text-center mx-auto">
                  <div
                    className={`toggle-button ${agencyPlan === "Monthly" ? "Monthly" : ""}`}
                    onClick={() => setAgencyPlan("Monthly")}
                  >
                    Monthly
                  </div>
                  <div
                    className={`toggle-button ${agencyPlan === "Annually" ? "Annually" : ""}`}
                    onClick={() => setAgencyPlan("Annually")}
                  >
                    Annually
                  </div>

                </div>
                <p className='mt-3' style={{ fontWeight: 'bold' }}>
                  {agencyPlan === "Monthly" ? "(Switch to annual plan to get 2 months free)" : "(2 Months Free)"}
                </p>
              </div>
            </div>
            )}

          </div>
        </div>

        {/* Toggle Styling */}
        <style>
          {`
            .card.shadow-lg {
              box-shadow: 0 10px 25px rgba(0,0,0,0.08) !important;
              border-radius: 16px;
            }

            .text-dollar {
              letter-spacing: 0.5px;
            }

            .toggle-container {
              display: flex;
              width: 150px;
              height: 40px;
              border-radius: 20px;
              background: #ccc;
              overflow: hidden;
              border: 1px solid #2e3192;
              margin: 0 auto;
            }

            .toggle-button {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 50%;
              height: 100%;
              cursor: pointer;
              transition: all 0.3s ease;
              color: white;
              font-weight: bold;
              background-color: #fff;
              color: #2e3192;
              font-size:12px;
            }

            .Annually {
              background-color: #2e3192 !important;
              color: #fff !important;
            }

            .Monthly {
              background-color: #2e3192 !important;
              color: #fff !important;
            }import PaymentManager from './PaymentManager';

          `}
        </style>
      </div>
    </SideNavbar>
  );
};

export default PricingSection;







